// 系统字段
import { useDispatch, useSelector } from 'dva';
import styles from './index.less?modules';
import classnames from 'classnames';
import { useEffect, useCallback } from 'react';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import { isEmptyObject } from '@/utils/comUtil.js';
import { history } from 'umi';

const CfpmDetail = () => {
  const baseInfo = {
    variableType: 'SYSTEM',
    fieldPackageId: history.location.query.id,
  };
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['cfpmDetail/getFieldList'];
  const bizData = useSelector((state) => state.cfpmDetail.fieldList);
  const searchValue = useSelector((state) => state.cfpmDetail.searchValue);
  // 条件查询列表
  const fetchData = useCallback(() => {
    dispatch({
      type: 'cfpmDetail/getFieldList',
      payload: {
        values: {
          ...searchValue,
          ...baseInfo,
        },
      },
    });
  }, [dispatch, searchValue]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className={styles.mm_content}>
      <div
        className={classnames(styles.search_group, styles.single_component1)}
      >
        <SearchGroup fetchData={fetchData} baseInfo={baseInfo} />
      </div>
      <div className={classnames(styles.table_page, styles.single_component)}>
        {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
        <TablePage
          pagination={{
            total: !isEmptyObject(bizData) ? bizData.length : 0,
          }}
          loading={loading}
          tableData={bizData}
          loadingstatus={loading}
          fetchData={fetchData}
        />
      </div>
    </div>
  );
};

export default CfpmDetail;
